import Details from './SpeedToLeadDetailsRoot';
import Route from './SpeedToLeadRoute';

export default {
  Details,
  Route,
};
